import type { FC } from 'react';

import type { IconProps } from './BaseIcon';
import { BaseIcon } from './BaseIcon';

export const AgentStudioIcon: FC<IconProps> = ({ size = 'sm', ...props }) => (
  <BaseIcon {...props} size={size} viewboxSize="sm" customFill>
    <path
      d="M0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8Z"
      fill="#D9EE50"
    />
    <path
      d="M8.01833 12.039C7.64488 12.039 7.34275 12.3438 7.34275 12.7211C7.34275 13.0985 7.64488 13.4031 8.01833 13.4031C8.39178 13.4031 8.69391 13.0984 8.69391 12.7211C8.69391 12.3438 8.39178 12.039 8.01833 12.039Z"
      fill="#161617"
    />
    <path
      d="M8.01833 2.55469C7.64488 2.55469 7.34275 2.85941 7.34275 3.23675C7.34275 3.61409 7.64488 3.91882 8.01833 3.91882C8.39178 3.91882 8.69391 3.6141 8.69391 3.23675C8.69391 2.85941 8.39178 2.55469 8.01833 2.55469Z"
      fill="#161617"
    />
    <path
      d="M11.5292 4.56316C11.1557 4.56316 10.8536 4.86789 10.8536 5.24523C10.8536 5.62257 11.1557 5.92729 11.5292 5.92729C11.9026 5.92729 12.2047 5.62257 12.2047 5.24523C12.2047 4.86789 11.9026 4.56316 11.5292 4.56316Z"
      fill="#161617"
    />
    <path
      d="M4.50749 4.56316C4.13404 4.56316 3.83191 4.86918 3.83191 5.24523C3.83191 5.62128 4.13404 5.92729 4.50749 5.92729C4.88094 5.92729 5.18307 5.62257 5.18307 5.24523C5.18307 4.86789 4.88094 4.56316 4.50749 4.56316Z"
      fill="#161617"
    />
    <path
      d="M11.5292 10.0306C11.1557 10.0306 10.8536 10.3353 10.8536 10.7126C10.8536 11.0899 11.1557 11.3947 11.5292 11.3947C11.9026 11.3947 12.2047 11.0899 12.2047 10.7126C12.2047 10.3353 11.9026 10.0306 11.5292 10.0306Z"
      fill="#161617"
    />
    <path
      d="M4.50749 10.0306C4.13404 10.0306 3.83191 10.3353 3.83191 10.7126C3.83191 11.0887 4.13404 11.3947 4.50749 11.3947C4.88094 11.3947 5.18307 11.0899 5.18307 10.7126C5.18307 10.3353 4.88094 10.0306 4.50749 10.0306Z"
      fill="#161617"
    />
    <path
      d="M6.26291 10.0251C6.63636 10.0251 6.93849 9.72045 6.93849 9.34308C6.93849 8.96571 6.63636 8.66101 6.26291 8.66101C5.88945 8.66101 5.58733 8.96574 5.58733 9.34308C5.58733 9.72042 5.88946 10.0251 6.26291 10.0251Z"
      fill="#161617"
    />
    <path
      d="M8.01833 8.65555C8.39178 8.65555 8.69391 8.35082 8.69391 7.97348C8.69391 7.59615 8.39178 7.29142 8.01833 7.29142C7.64488 7.29142 7.34275 7.59614 7.34275 7.97348C7.34275 8.35083 7.64488 8.65555 8.01833 8.65555Z"
      fill="#161617"
    />
    <path
      d="M8.01833 11.3947C8.39178 11.3947 8.69391 11.0899 8.69391 10.7126C8.69391 10.3353 8.39178 10.0306 8.01833 10.0306C7.64488 10.0306 7.34275 10.3353 7.34275 10.7126C7.34275 11.0899 7.64488 11.3947 8.01833 11.3947Z"
      fill="#161617"
    />
    <path
      d="M8.01833 5.92729C8.39178 5.92729 8.69391 5.62257 8.69391 5.24523C8.69391 4.86789 8.39178 4.56316 8.01833 4.56316C7.64488 4.56316 7.34275 4.86789 7.34275 5.24523C7.34275 5.62257 7.64488 5.92729 8.01833 5.92729Z"
      fill="#161617"
    />
    <path
      d="M11.5292 8.65555C11.9026 8.65555 12.2047 8.35082 12.2047 7.97348C12.2047 7.59615 11.9026 7.29142 11.5292 7.29142C11.1557 7.29142 10.8536 7.59614 10.8536 7.97348C10.8536 8.35083 11.1557 8.65555 11.5292 8.65555Z"
      fill="#161617"
    />
    <path
      d="M4.50749 8.65555C4.88094 8.65555 5.18307 8.35082 5.18307 7.97348C5.18307 7.59615 4.88094 7.29142 4.50749 7.29142C4.13405 7.29142 3.83191 7.59614 3.83191 7.97348C3.83191 8.35083 4.13404 8.65555 4.50749 8.65555Z"
      fill="#161617"
    />
    <path
      d="M9.77376 10.0251C10.1472 10.0251 10.4493 9.72045 10.4493 9.34308C10.4493 8.96571 10.1472 8.66101 9.77376 8.66101C9.40031 8.66101 9.09818 8.96574 9.09818 9.34308C9.09818 9.72042 9.40031 10.0251 9.77376 10.0251Z"
      fill="#161617"
    />
    <path
      d="M6.26291 7.29142C6.63636 7.29142 6.93849 6.9867 6.93849 6.60936C6.93849 6.23201 6.63636 5.92729 6.26291 5.92729C5.88945 5.92729 5.58733 6.23202 5.58733 6.60936C5.58733 6.98669 5.88946 7.29142 6.26291 7.29142Z"
      fill="#161617"
    />
    <path
      d="M9.77376 7.29142C10.1472 7.29142 10.4493 6.9867 10.4493 6.60936C10.4493 6.23201 10.1472 5.92729 9.77376 5.92729C9.40031 5.92729 9.09818 6.23202 9.09818 6.60936C9.09818 6.98669 9.40031 7.29142 9.77376 7.29142Z"
      fill="#161617"
    />
  </BaseIcon>
);
